import { AxiosPromise, AxiosStatic } from "axios";
import {
  Investment,
  EISFundInvestmentResponse,
  EISFundInvestmentSearchRequest,
} from "../types/Investment";

export const findInvestmentById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (investmentId: string): AxiosPromise<Investment> =>
    await appAxios.get(`${serverURL}/investments/${investmentId}`, {
      withCredentials: true,
    });

export const getEISFundInvestments =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    commitmentId: string,
    params?: EISFundInvestmentSearchRequest
  ): AxiosPromise<EISFundInvestmentResponse> =>
    await appAxios.get(`${serverURL}/investments/eis-fund/${commitmentId}`, {
      params,
      withCredentials: true,
    });
